import * as React from 'react';
import {Box, Typography, Card, Stack, useTheme, IconButton, Collapse} from '@mui/material';
import { next_rank } from 'assets/utils';
import PercentageBar from 'components/PercentageBar';
import { RankLabel } from 'components/PercentageBar';
import PointsIcon from 'components/PointsIcon';
import SeriesIcon from 'components/SeriesIcon';
import InfoIcon from '@mui/icons-material/Info';
import ShadowBox from 'components/ShadowBox';
import { useTranslation } from "react-i18next";

export function CircuitPredictionCard({circuit, isFemale, data, currentRank}) {
    const theme = useTheme();
    const { t } = useTranslation();

    const marks = [];

    if (data["mi"] && data["mi"] > 0) {
        marks.push({
            rank: circuit,
            value: data["mi"],
            label: "P" + circuit, 
            points: Math.round(100*data["mi"]) + "%",
            color: circuit <= currentRank ? theme.palette.primary.dark : theme.palette.primary.main
        })
    }

    if (data["ma"] && data["ma"] < 1) {
        const nextRank = next_rank(circuit, isFemale);

        marks.push({
            rank: nextRank,
            value: data["ma"],
            label: "P" + nextRank, 
            points: Math.round(100*data["ma"]) + "%",
            color: nextRank <= currentRank ? theme.palette.primary.dark : theme.palette.primary.main
        })
    }

    const [open, setOpen] = React.useState(false);

    return <ShadowBox sx={{mt: 1, opacity: data.v ? 1 : 0.5, border: (theme) => '1px solid ' + theme.palette.primary.main, overflow: "hidden"}}>
    <Box sx={{pl: 1.5, py: 0, backgroundColor: "primary.main", display: "flex"}} flexDirection="column" justifyContent="center">
        <Stack flexDirection="row" alignItems="center">
            <Typography variant="body" color="common.white" sx={{fontWeight: "bold", mr: 1}}>
                {t("calculation.circuitTitle")}
            </Typography>
            
            <RankLabel text={"P" + circuit} color={theme.palette.primary.primary} stroke="white" />
            {/*<SeriesIcon prefix="P" circuit={circuit} />*/}

            <IconButton>
                <InfoIcon style={{color: "white", opacity: 0.8}} fontSize='medium' onClick={() => setOpen(!open)}/>
            </IconButton>
        </Stack>
    </Box>
    <Box sx={{display: "flex", justifyContent: "center"}}>
        <PercentageBar 
        marks={marks}
        percentage={100 * data.ratio}
        currentValue={circuit < currentRank ? data["ma"] : (circuit == currentRank ? data["mi"] : 0)}
        predictedValue={data.ratio}
        marksFrom={0}
        marksTo={1}
    />
    </Box>
    <Box sx={{display: "flex", justifyContent: "flex-end", mr: '19px', mb: 1}}>
        {data.cor ? <Typography variant="caption" color="text.secondary" sx={{px: 1.5, display: "block", textAlign: "left", flexGrow: 1}}>
            {t("calculation.manyPlayerCorrection", {value: data.cor})}
        </Typography> : null}
        <PointsIcon points={data.wp} isWp />
        <PointsIcon points={data.vp} correction={data.cor} />
    </Box>
    

    <AdditionalInfo data={data} open={open} />
</ShadowBox>
}

function round2(v) {
    return Math.round(100*v)/100;
}

function AdditionalInfo({data, open}) {
    const { t } = useTranslation();

    return <Collapse in={open}>
      <Box sx={{color: "white", backgroundColor: "primary.main", px: 1.5, py: 1}}>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 110, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>{t("calculation.numberOfMatches")}</Typography> {data["nm"]}
        </Typography>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 20, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>WP</Typography> {round2(data["wp"])} = {data["wpb"].map((el, index) => index > 0 ? (el >= 0 ? " + " : " - ") + round2(Math.abs(el)) : round2(Math.abs(el)))}
        </Typography>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 20, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>VP</Typography> {round2(data["vp"])} = {data["vpb"].map((el, index) => index > 0 ? (el >= 0 ? " + " : " - ") + round2(Math.abs(el)) : round2(Math.abs(el)))}
        </Typography>
        <Typography sx={{fontWeight: "bold", fontSize: 12}} component="div">
            <Typography sx={{width: 35, display: "inline-block", fontWeight: "inherit", fontSize: 'inherit'}}>{t("calculation.ratio")}</Typography> {round2(data["wp"])} / ({round2(data["wp"])} + {round2(data["vp"])}) = {round2(100*data["ratio"])}%
        </Typography>
      </Box>
      </Collapse>
}